import React from "react";
import Loadable from "../../react-loadable";

const WeaRate = Loadable({
  loader: () => import("./Rate"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaRate;



// WEBPACK FOOTER //
// ./ecology9/wea-rate/index.js